/* Пароли и ссылки — общее хранилище доступов команды.
   Список один на всех, поиск идёт по названию, адресу и логину на месте:
   записей десятки, за ними незачем ходить в сеть на каждую букву. */

import { List, ListItem, Searchbar } from "konsta/react";
import React, { useState } from "react";
import { useNavigate } from "../lib/router.jsx";

import AddButton from "../components/AddButton.jsx";
import { Ion, IconTile } from "../components/icons.jsx";
import Screen from "../components/Screen.jsx";
import { SkelList } from "../components/skeleton.jsx";
import { Empty, ErrorState } from "../components/ui.jsx";
import { useFetch } from "../lib/store.jsx";
import { haptic } from "../lib/tg.js";

const TILE = "#30b0c7";

const ITEM_COLORS = {
  primaryTextIos: "text-[color:var(--tg-text)]",
  secondaryTextIos: "text-[color:var(--tg-hint)]",
};

/* Справа у строки — логин, а если его нет, домен из ссылки: по нему запись
   узнаётся быстрее, чем по полному адресу */
const host = (url) => {
  if (!url) return null;
  try {
    return new URL(/^https?:/i.test(url) ? url : `https://${url}`).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

export default function Passwords() {
  const { data, loading, error, refetch } = useFetch("/passwords");
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const needle = q.trim().toLowerCase();
  const items = (data || []).filter(
    (p) => !needle || [p.name, p.url, p.login].some((v) => String(v || "").toLowerCase().includes(needle))
  );

  return (
    <Screen back title="Пароли и ссылки" bottomPad={110}>
      {/* Konsta не пробрасывает className в Searchbar, поэтому отступы держит
          обёртка — те же ml-safe-4/mr-safe-4, что у inset-списка под ней */}
      <div className="px-safe-4">
        <Searchbar
          placeholder="Поиск"
          value={q}
          onInput={(e) => setQ(e.target.value)}
          onClear={() => setQ("")}
        />
      </div>

      {loading ? <SkelList /> : null}
      {error ? <ErrorState text={error} onRetry={refetch} /> : null}

      {!loading && !error && !items.length ? (
        <Empty text={needle ? "Ничего не нашлось" : "Записей пока нет"} icon={Ion.key} />
      ) : null}

      {items.length ? (
        <List strong inset>
          {items.map((p) => (
            <ListItem
              key={p.id}
              link
              colors={ITEM_COLORS}
              media={<IconTile icon={Ion.keySolid} bg={TILE} />}
              title={p.name}
              after={p.login || host(p.url)}
              onClick={() => { haptic.light(); navigate(`/edit/passwords/${p.id}`); }}
            />
          ))}
        </List>
      ) : null}

      <AddButton onClick={() => { haptic.medium(); navigate("/edit/passwords/new"); }} />
    </Screen>
  );
}
